import React from "react";
import { HeaderConfig, appliedConfig } from "../config/commonConfig";

function Pricing() {
  return (
    <section
      id="pricing"
      className={
        "section bg-light " +
        (appliedConfig.appliedHeader === HeaderConfig.SideHeaderDark ||
        appliedConfig.appliedHeader === HeaderConfig.SideHeaderLight
          ? "px-lg-4 "
          : " ")
      }>
      <div className="container">
        <h2 className="text-9 fw-600 text-center">Pelada+ Premium</h2>
        <hr className="heading-separator-line bg-primary opacity-10 mx-auto" />
        <p className="lead text-center mb-5">
          Assine o Premium e amplia as suas possibilidades!
        </p>
        <div className="row gy-4 justify-content-center">
          <div className="col-sm-6 col-lg-3">
            <div className="card text-center border-0 shadow-md">
              <div className="card-header text-6 fw-500 text-bg-secondary border-bottom-0 py-4">
                Básico
              </div>
              <div className="card-body">
                <h5 className="text-9 fw-600 mb-0">Grátis</h5>
                <p className=" text-2 badge fw-600 rounded-pill">-</p>
                <ul className="list-style-2 text-2 text-start">
                  <li className="text-center">Apenas um grupo</li>
                  <li className="text-center">Número ilimitado de jogadores</li>
                  <li className="text-center">Times de 5 a 7 jogadores</li>
                  <li className="text-center">-</li>
                  <li className="text-center">Com propagandas</li>
                </ul>
              </div>
            </div>
          </div>
          <div className="col-sm-6 col-lg-3">
            <div className="card text-center border-0 shadow-md">
              <div className="card-header text-6 fw-500 text-bg-primary border-bottom-0 py-4">
                Premium
              </div>
              <div className="card-body">
                <h5 className="text-9 fw-600 mb-0">R$ 19,90</h5>
                <p className=" text-2 badge text-bg-warning fw-600 rounded-pill">
                  Anual
                </p>
                <ul className="list-style-2 text-2 text-start">
                  <li className="text-center">Número ilimitado de grupos</li>
                  <li className="text-center">Número ilimitado de jogadores</li>
                  <li className="text-center">Times de 4 a 11 jogadores</li>
                  <li className="text-center">Gerenciamento de estatísticas</li>
                  <li className="text-center">Sem propagandas</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Pricing;
